import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoVestfoldOgTelemarkPrimaerBokmaalNegativPdf,
  LogoVestfoldOgTelemarkPrimaerBokmaalNegativPng,
  LogoVestfoldOgTelemarkPrimaerBokmaalNegativSvg,
  LogoVestfoldOgTelemarkPrimaerBokmaalPositivPdf,
  LogoVestfoldOgTelemarkPrimaerBokmaalPositivPng,
  LogoVestfoldOgTelemarkPrimaerBokmaalPositivSvg,
  LogoVestfoldOgTelemarkPrimaerBokmaalEngelskNegativPdf,
  LogoVestfoldOgTelemarkPrimaerBokmaalEngelskNegativPng,
  LogoVestfoldOgTelemarkPrimaerBokmaalEngelskNegativSvg,
  LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivPdf,
  LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivPng,
  LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivSvg,
  LogoVestfoldOgTelemarkPrimaerNynorskNegativPdf,
  LogoVestfoldOgTelemarkPrimaerNynorskNegativPng,
  LogoVestfoldOgTelemarkPrimaerNynorskNegativSvg,
  LogoVestfoldOgTelemarkPrimaerNynorskPositivPdf,
  LogoVestfoldOgTelemarkPrimaerNynorskPositivPng,
  LogoVestfoldOgTelemarkPrimaerNynorskPositivSvg,
  LogoVestfoldOgTelemarkPrimaerNynorskEngelskNegativPdf,
  LogoVestfoldOgTelemarkPrimaerNynorskEngelskNegativPng,
  LogoVestfoldOgTelemarkPrimaerNynorskEngelskNegativSvg,
  LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivPdf,
  LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivPng,
  LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivSvg,
  LogoVestfoldOgTelemarkSekundaerBokmaalNegativPdf,
  LogoVestfoldOgTelemarkSekundaerBokmaalNegativPng,
  LogoVestfoldOgTelemarkSekundaerBokmaalNegativSvg,
  LogoVestfoldOgTelemarkSekundaerBokmaalPositivPdf,
  LogoVestfoldOgTelemarkSekundaerBokmaalPositivPng,
  LogoVestfoldOgTelemarkSekundaerBokmaalPositivSvg,
  LogoVestfoldOgTelemarkSekundaerBokmaalEngelskNegativPdf,
  LogoVestfoldOgTelemarkSekundaerBokmaalEngelskNegativPng,
  LogoVestfoldOgTelemarkSekundaerBokmaalEngelskNegativSvg,
  LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivPdf,
  LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivPng,
  LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivSvg,
  LogoVestfoldOgTelemarkSekundaerNynorskNegativPdf,
  LogoVestfoldOgTelemarkSekundaerNynorskNegativPng,
  LogoVestfoldOgTelemarkSekundaerNynorskNegativSvg,
  LogoVestfoldOgTelemarkSekundaerNynorskPositivPdf,
  LogoVestfoldOgTelemarkSekundaerNynorskPositivPng,
  LogoVestfoldOgTelemarkSekundaerNynorskPositivSvg,
  LogoVestfoldOgTelemarkSekundaerNynorskEngelskNegativPdf,
  LogoVestfoldOgTelemarkSekundaerNynorskEngelskNegativPng,
  LogoVestfoldOgTelemarkSekundaerNynorskEngelskNegativSvg,
  LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivPdf,
  LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivPng,
  LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivSvg,
  LogoVestfoldOgTelemarkSentrertBokmaalNegativPdf,
  LogoVestfoldOgTelemarkSentrertBokmaalNegativPng,
  LogoVestfoldOgTelemarkSentrertBokmaalNegativSvg,
  LogoVestfoldOgTelemarkSentrertBokmaalPositivPdf,
  LogoVestfoldOgTelemarkSentrertBokmaalPositivPng,
  LogoVestfoldOgTelemarkSentrertBokmaalPositivSvg,
  LogoVestfoldOgTelemarkSentrertBokmaalEngelskNegativPdf,
  LogoVestfoldOgTelemarkSentrertBokmaalEngelskNegativPng,
  LogoVestfoldOgTelemarkSentrertBokmaalEngelskNegativSvg,
  LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivPdf,
  LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivPng,
  LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivSvg,
  LogoVestfoldOgTelemarkSentrertNynorskNegativPdf,
  LogoVestfoldOgTelemarkSentrertNynorskNegativPng,
  LogoVestfoldOgTelemarkSentrertNynorskNegativSvg,
  LogoVestfoldOgTelemarkSentrertNynorskPositivPdf,
  LogoVestfoldOgTelemarkSentrertNynorskPositivPng,
  LogoVestfoldOgTelemarkSentrertNynorskPositivSvg,
  LogoVestfoldOgTelemarkSentrertNynorskEngelskNegativPdf,
  LogoVestfoldOgTelemarkSentrertNynorskEngelskNegativPng,
  LogoVestfoldOgTelemarkSentrertNynorskEngelskNegativSvg,
  LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivPdf,
  LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivPng,
  LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Vestfold-og-Telemark/exportVestfoldOgTelemark.js";

export default function VestfoldOgTelemarkPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Vestfold og Telemark"
          lead="Alle logoer for Vestfold og Telemark i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, bokmål"
                    text="Bokmål"
                    blackSvg={LogoVestfoldOgTelemarkPrimaerBokmaalPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkPrimaerBokmaalPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkPrimaerBokmaalNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkPrimaerBokmaalNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoVestfoldOgTelemarkPrimaerNynorskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkPrimaerNynorskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkPrimaerNynorskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkPrimaerNynorskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkPrimaerNynorskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSekundaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, bokmål"
                    text="Bokmål"
                    blackSvg={LogoVestfoldOgTelemarkSekundaerBokmaalPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSekundaerBokmaalPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSekundaerBokmaalNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSekundaerBokmaalNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSekundaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoVestfoldOgTelemarkSekundaerNynorskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSekundaerNynorskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSekundaerNynorskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSekundaerNynorskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSekundaerNynorskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSentrertBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, bokmål"
                    text="Bokmål"
                    blackSvg={LogoVestfoldOgTelemarkSentrertBokmaalPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSentrertBokmaalPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSentrertBokmaalPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSentrertBokmaalNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSentrertBokmaalNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSentrertNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoVestfoldOgTelemarkSentrertNynorskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSentrertNynorskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSentrertNynorskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSentrertNynorskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSentrertNynorskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Vestfold og Telemark, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoVestfoldOgTelemarkSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoVestfoldOgTelemarkSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoVestfoldOgTelemarkSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoVestfoldOgTelemarkSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
